import { render, staticRenderFns } from "./ModalDesignatedPositionFeedConformation.vue?vue&type=template&id=18ba1c34"
import script from "./ModalDesignatedPositionFeedConformation.vue?vue&type=script&lang=js"
export * from "./ModalDesignatedPositionFeedConformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports